import React from "react";
import "./HeroAbout.css";
import aboutBG from "../assets/about-bg.png";

export default function HeroAbout() {
  return (
    <section
      className="hero-about"
      style={{ backgroundImage: `url(${aboutBG})` }}
    >
      <div className="hero-about-overlay"></div>
      <div className="hero-about-content">
        <div className="text-content">
          <h1>About Us</h1>
          <p>
            Elevate Your Projects with Our Premium Paints and A Comprehensive Selection of Paints and Accessories
          </p>
        </div>
        <button>Learn More</button>
      </div>
    </section>
  );
}
